import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PageHeader } from "@/components/shared/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function AddCompanyPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <PageHeader
        title={t("header.addCompany")}
        description={t("settings.addCompany.comingSoon")}
      />
      <Card>
        <CardContent className="pt-6">
          <Button variant="outline" asChild>
            <Link to="/settings">{t("pages.common.back")}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
